import React from 'react'
import { xinyiHero } from './content'
import type { Lang } from './types'

interface XinyiHeroV2Props {
  currentLang: Lang
}

/**
 * XinyiHeroV2
 * Full-bleed image hero with bottom-aligned big serif title — mirrors the
 * Barista Map "one image, one big word" rule used across all V2 pages.
 *
 * SEO: page H1 lives here as <h1 className="sr-only"> with the original
 * Xinyi long-tail copy preserved (per "do not break SEO" requirement).
 */
const XinyiHeroV2: React.FC<XinyiHeroV2Props> = ({ currentLang }) => {
  return (
    <section className="relative h-[70vh] min-h-[480px] w-full overflow-hidden bg-black">
      {/* SEO H1 — visually hidden, content preserved from XinyiStorePage */}
      <h1 className="sr-only">{xinyiHero.seoH1[currentLang]}</h1>

      <div className="absolute inset-0">
        <img
          src={xinyiHero.image}
          alt={xinyiHero.imageAlt[currentLang]}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/55 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto flex h-full max-w-[1600px] items-end px-6 pb-12 md:px-10 md:pb-16">
        <p
          className="text-white"
          style={{
            fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
            fontWeight: 400,
            fontSize: 'clamp(2.25rem, 5vw, 4rem)',
            letterSpacing: '0.02em',
            lineHeight: 1.1,
          }}
        >
          {xinyiHero.title[currentLang]}
        </p>
      </div>
    </section>
  )
}

export default XinyiHeroV2
